const KEY_PREFIX = "instant-assistant:voice-opt-in";

function getKey(namespaceId: string): string {
  return `${KEY_PREFIX}:${namespaceId}`;
}

export function loadVoiceOptIn(namespaceId: string): boolean {
  if (typeof window === "undefined" || !namespaceId) {
    return false;
  }

  try {
    return window.localStorage.getItem(getKey(namespaceId)) === "1";
  } catch (error) {
    console.warn("Instant assistant voice opt-in read failed", error);
    return false;
  }
}

export function persistVoiceOptIn(namespaceId: string, enabled: boolean): void {
  if (typeof window === "undefined" || !namespaceId) {
    return;
  }

  try {
    const key = getKey(namespaceId);
    if (enabled) {
      window.localStorage.setItem(key, "1");
    } else {
      window.localStorage.removeItem(key);
    }
  } catch (error) {
    console.warn("Instant assistant voice opt-in write failed", error);
  }
}
